export const getActionType = (type: string) => `api/executeQuery/${type}`;
